import React from 'react';
import { PropTypes } from 'prop-types';

import { Button } from '@ontruck/orc';

const Actions = ({ className, t, handleClose, handleAccept }) => (
  <div className={className}>
    <Button
      text={t('actions.discard')}
      fullWidth
      nude
      skin="primary"
      onClick={handleClose}
    />
    <Button text={t('actions.accept')} fullWidth onClick={handleAccept} />
  </div>
);

Actions.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func,
  handleClose: PropTypes.func,
  handleAccept: PropTypes.func,
};

Actions.defaultProps = {
  className: '',
  t: (t) => t,
  handleClose: () => ({}),
  handleAccept: () => ({}),
};

export default Actions;
